import { LoggedUser } from '@/core/types/LoggedUser'
import { SystemModuleName } from '@/core/types/SystemModuleName.ts'

export interface globalState {
  loggedUser: LoggedUser | null
  loggedUserStatus: 'loggedInError' | 'loggedInBlocked' | null
  isLoading: boolean
  currentModuleName: SystemModuleName | null
  isSidebarOpen: boolean
  isLinkAccountModalOpen: boolean
  isBranchOfficeLocationModalOpen: boolean
}

export const initialState: globalState = {
  loggedUser: null,
  loggedUserStatus: null,
  isLoading: false,
  currentModuleName: null,
  isSidebarOpen: true,
  isLinkAccountModalOpen: false,
  isBranchOfficeLocationModalOpen: false
}
